import list from 'src/modules/dataStudio/list/dataStudioListReducers';
import form from 'src/modules/dataStudio/form/dataStudioFormReducers';
import view from 'src/modules/dataStudio/view/dataStudioViewReducers';
import destroy from 'src/modules/dataStudio/destroy/dataStudioDestroyReducers';
import importerReducer from 'src/modules/dataStudio/importer/dataStudioImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
